module.exports = __webpack_public_path__ + "img/GS_Profile-Sazi Jali.939fd678.png";